import React, { createContext, useState, useEffect, useContext, navigate } from 'react';
import { getProfile, changePassword } from '../auth'; // Make sure this file is correctly imported
import { Spin } from 'antd';

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    // Check token on component mount
    useEffect(() => {
        const checkAuth = async () => {
            //console.log('Auth')
            const token = localStorage.getItem('token');
            if (token) {
                try {
                    await getProfile(); // Verify token validity by making a request
                    setIsAuthenticated(true);
                } catch (error) {
                    setIsAuthenticated(false);
                    localStorage.removeItem('token'); // Clear invalid token
                }
            } else {
                setIsAuthenticated(false);
            }
            setLoading(false);
        };

        checkAuth();
    }, []);



    const login = (token) => {
        localStorage.setItem('token', token);
        setIsAuthenticated(true);
        //navigate('/dashboard'); // Redirect on successful login
    };

    const updatePassword = async (values) => {
        try {
            return await changePassword(values); // Verify token validity by making a request

        } catch (error) {
            console.error('Password update failed:', error);
            return error
        }

    };

    const logout = () => {
        localStorage.removeItem('token');
        setIsAuthenticated(false);
        //navigate('/login'); // Redirect to login page
    };

    if (loading) return <Spin fullscreen={true} size={'large'}>
        <div className="spinner"></div>
    </Spin>; // Optional: show a loading indicator

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout, updatePassword }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
